import { classNames } from 'primereact/utils';
import React, { useState } from 'react';
import { Form, FormSpy } from 'react-final-form';
import FormContext from '../../../../api/contexts.js';
import { GridContainer } from '../../../../components/customComponents/GridContainer.js';

const C2Form = (props) => {
    const [formData, setFormData] = useState({});
    return props.layouts ? (React.createElement("div", { className: classNames("h-full w-full") },
        React.createElement(Form, { initialValues: props.value, onSubmit: (e) => {
            }, render: ({ handleSubmit, submitting, pristine, form, initialValues }) => {
                return (React.createElement(FormContext.Provider, { value: { value: props.name, initialValue: props.value } },
                    React.createElement(GridContainer, { layouts: props.layouts, "data-test-id": props["data-test-id"], className: props.className, cols: props.cols, isGroup: props.isGroup }, props.children),
                    React.createElement(FormSpy, { subscription: { values: true }, onChange: (e) => {
                            const values = Object.assign({}, e.values);
                            Object.keys(values).forEach((key) => {
                                if (values[key] instanceof Date) {
                                    values[key] = values[key].toISOString();
                                }
                            });
                            if (props.onChange) {
                                props.onChange(values);
                            }
                        } })));
            } }))) : (React.createElement("div", { className: props.className },
        React.createElement(Form, { initialValues: formData, onSubmit: (e) => {
            }, render: ({ handleSubmit, submitting, pristine, form }) => (React.createElement(FormContext.Provider, { value: props.name },
                props.children,
                React.createElement(FormSpy, { subscription: { values: true }, onChange: (e) => {
                        const values = Object.assign({}, e.values);
                        Object.keys(values).forEach((key) => {
                            if (values[key] instanceof Date) {
                                values[key] = values[key].toISOString();
                            }
                        });
                        if (props.onChange) {
                            props.onChange(values);
                        }
                    } }))) })));
};

export { C2Form as default };
//# sourceMappingURL=index.js.map
